import styled from "styled-components";

//Types
interface LayoutProps {
  $isOpen: boolean;
}

export const Layout = styled.div<LayoutProps>`
  display: flex;
  min-height: 100vh;
  margin-left: 0;
  transition: margin-left 0.3s ease-in-out;
  padding-top: 4.5em;
  position: relative;

  &:before {
    content: "";
    display: block;
    position: absolute;
    background: #000;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s;

    ${({ $isOpen }) =>
      $isOpen &&
      `
        opacity: 0.3;
        visibility: visible;
    `};

    @media (min-width: 992px) {
      visibility: hidden;
      opacity: 0;
    }
  }

  @media (min-width: 768px) {
    margin-left: 68px;
    padding-top: 4.5em;
  }

  @media (min-width: 992px) {
    margin-left: ${({ $isOpen }) => ($isOpen ? "16rem" : "68px")};

    &:before {
      display: none;
    }
  }
`;

export const ContentLayout = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 4.5em);
  overflow: hidden;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @media (min-width: 768px) {
    padding: 20px;
  }
`;
